import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetCalendars } from "api/generated/calendars/calendars";

import { CONTROL_LIST_QUERY_OPTIONS } from "./controlListQueryOptions";

export function useCalendarsQuery() {
    return useGetCalendars({
        query: {
            ...CONTROL_LIST_QUERY_OPTIONS,
            select: (response) =>
                response.data.content.map((item) => item.resource),
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
